import { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import * as api from "@/lib/api";
import { UserManagementPanel, ALL_ROLE_OPTIONS } from "@/components/user-management-panel";

const allSchoolRoles = ALL_ROLE_OPTIONS.filter((r) => r.scopeType === "school");

export default function SchoolUsersPage() {
  const { id } = useParams<{ id: string }>();
  const { user: authUser } = useAuth();
  const [schoolName, setSchoolName] = useState("");

  // school_admin can only assign coach; org_admin/super_admin can assign both
  const assignableRoles = useMemo(() => {
    const isSchoolAdminOnly =
      !authUser?.roles.some((r) => r.role_type === "super_admin" && r.scope_type === "platform") &&
      !authUser?.roles.some((r) => r.role_type === "org_admin" && r.scope_type === "organization");
    if (isSchoolAdminOnly) return allSchoolRoles.filter((r) => ["coach", "super_parent", "parent", "player"].includes(r.value));
    return allSchoolRoles;
  }, [authUser?.roles]);

  useEffect(() => {
    if (id) {
      api.getSchool(id).then((r) => setSchoolName(r.school.name)).catch(() => {});
    }
  }, [id]);

  if (!id) return null;

  return (
    <div data-page="school-users">
    <UserManagementPanel
      title={schoolName ? `${schoolName} -- Users` : "School Users"}
      subtitle="Users with roles at this school"
      scopeType="school"
      scopeId={id}
      fetchUsers={() => api.getSchoolUsers(id)}
      assignableRoles={assignableRoles}
      canManage={true}
      showDetailLink
    />
    </div>
  );
}
